import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { Button } from '@orijinworks/frontend-commons';
import { useCasePlanCreateActionsStyles } from './CasePlanCreateActions.styles';

/**
 * Footer actions for Create Plan: Create Plan(s) (primary) and Cancel (outlined).
 */
export const CasePlanCreateActions = ({
  canCreate,
  isSubmitting,
  createLabel,
  onCreate,
  onCancel,
}) => {
  const classes = useCasePlanCreateActionsStyles();
  const isCreateDisabled = !canCreate || isSubmitting;

  return (
    <Box className={classes.root}>
      <Button
        variant="contained"
        color="primary"
        disabled={isCreateDisabled}
        onClick={onCreate}
        className={isCreateDisabled ? classes.createDisabled : classes.createEnabled}
      >
        {createLabel}
      </Button>
      <Button
        variant="outlined"
        color="primary"
        onClick={onCancel}
        disabled={isSubmitting}
        className={classes.cancel}
      >
        Cancel
      </Button>
    </Box>
  );
};

CasePlanCreateActions.propTypes = {
  canCreate: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  createLabel: PropTypes.string,
  onCreate: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

CasePlanCreateActions.defaultProps = {
  createLabel: 'Create Plan',
};

export default CasePlanCreateActions;
